<template>
  <div class="content">
    <div class="content__title content__title--party content__title--start">
      <router-link
        :to="{ name: 'users-admins' }"
        class="button button--light button--no-indent button--small"
      >
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.70917 13.7082C7.61629 13.8013 7.50595 13.8752 7.38447 13.9256C7.263 13.976 7.13277 14.002 7.00125 14.002C6.86973 14.002 6.7395 13.976 6.61802 13.9256C6.49655 13.8752 6.38621 13.8013 6.29332 13.7082L0.293962 7.70884C0.200846 7.61595 0.126968 7.50562 0.0765611 7.38414C0.0261537 7.26266 0.000206594 7.13243 0.000206606 7.00091C0.000206617 6.86939 0.0261537 6.73916 0.0765611 6.61769C0.126969 6.49621 0.200846 6.38587 0.293962 6.29299L6.29333 0.293626C6.48108 0.105873 6.73573 0.00039471 7.00125 0.000394734C7.26677 0.000394757 7.52142 0.105873 7.70918 0.293626C7.89693 0.481379 8.00241 0.736028 8.00241 1.00155C8.00241 1.26707 7.89693 1.52172 7.70917 1.70948L2.41574 7.00091L7.70917 12.2923C7.80229 12.3852 7.87617 12.4956 7.92658 12.617C7.97698 12.7385 8.00293 12.8688 8.00293 13.0003C8.00293 13.1318 7.97698 13.262 7.92658 13.3835C7.87617 13.505 7.80229 13.6153 7.70917 13.7082Z" fill="#2B93E7"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16 7.00108C16 7.26627 15.8947 7.5206 15.7071 7.70811C15.5196 7.89563 15.2653 8.00098 15.0001 8.00098L2.00149 8.00098C1.7363 8.00098 1.48197 7.89563 1.29445 7.70811C1.10694 7.5206 1.00159 7.26627 1.00159 7.00108C1.00159 6.73589 1.10694 6.48156 1.29445 6.29405C1.48197 6.10653 1.7363 6.00119 2.00149 6.00119L15.0001 6.00119C15.2653 6.00119 15.5196 6.10653 15.7071 6.29405C15.8947 6.48157 16 6.73589 16 7.00108Z" fill="#2B93E7"/>
        </svg>
      </router-link>
      <h1 class="title title--big title--theme">Добавление администратора</h1>
    </div>
    <form class="form" @submit.prevent="onCheckForm">
      <div class="form__content">
        <div class="form__part">
          <div class="form-group">
            <label for="fio">ФИО<sup>*</sup></label>
            <div class="form-control" :class="{ 'form-control--error': $v.form.fio.$error }">
              <input
                id="fio"
                type="text"
                class="form-control__input"
                name="fio"
                placeholder="Введите ФИО"
                v-model.trim="form.fio"
              />
            </div>
            <div class="form-group__error" v-if="$v.form.fio.$dirty && !$v.form.fio.required">Обязательное поле</div>
          </div>
          <div class="form-group">
            <label for="email">Электронная почта<sup>*</sup></label>
            <div class="form-control" :class="{ 'form-control--error': $v.form.email.$error }">
              <input
                id="email"
                type="text"
                class="form-control__input"
                name="email"
                placeholder="Введите электронную почту"
                v-model.trim="form.email"
              />
            </div>
            <div class="form-group__error" v-if="$v.form.email.$dirty && !$v.form.email.required">Обязательное поле</div>
          </div>
          <div class="form-group">
            <label for="phone_number">Телефон<sup>*</sup></label>
            <div class="form-control" :class="{ 'form-control--error': $v.form.phone_number.$error }">
              <masked-input
                v-model.trim="form.phone_number"
                name="phone_number"
                mask="\+71111111111"
                placeholder-char=" "
                placeholder="Введите номер телефона"
                class="form-control__input"
                id="phone_number"
                autocomplete="off"
                @blur.native="$v.form.phone_number.$touch"
              />
            </div>
            <div class="form-group__error" v-if="$v.form.phone_number.$dirty && !$v.form.phone_number.required">
              Обязательное поле
            </div>
          </div>
        </div>
        <div class="form__part">
          <div class="form-group">
            <label for="login">Логин<sup>*</sup></label>
            <div class="form-control" :class="{ 'form-control--error': $v.form.username.$error }">
              <input
                id="login"
                type="text"
                class="form-control__input"
                name="login"
                placeholder="Укажите логин"
                v-model.trim="form.username"
              />
            </div>
            <div class="form-group__error" v-if="$v.form.username.$dirty && !$v.form.username.required">Обязательное поле</div>
          </div>
          <div class="form-group">
            <div class="form-group__party form-group__party--between">
              <label for="password">Пароль<sup>*</sup></label>
              <button @click="onPasswordGen" type="button" class="form-group__btn">Сгенерировать пароль</button>
            </div>
            <div class="form-control" :class="{ 'form-control--error': $v.form.password.$error }">
              <input
                id="password"
                :type="show_pass ? 'text' : 'password'"
                name="password"
                class="form-control__input"
                placeholder="Укажите пароль"
                v-model.trim="form.password"
                @change="$v.form.password.$touch()"
              />
              <button
                @click="show_pass = !show_pass"
                type="button"
                class="form-control__btn"
              >
                <svg v-show="show_pass" width="25" height="25" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.95898 11.4999C1.95898 11.4999 5.79232 3.83325 12.5007 3.83325C19.209 3.83325 23.0423 11.4999 23.0423 11.4999C23.0423 11.4999 19.209 19.1666 12.5007 19.1666C5.79232 19.1666 1.95898 11.4999 1.95898 11.4999Z" stroke="#C7CFDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 14.375C14.0878 14.375 15.375 13.0878 15.375 11.5C15.375 9.91218 14.0878 8.625 12.5 8.625C10.9122 8.625 9.625 9.91218 9.625 11.5C9.625 13.0878 10.9122 14.375 12.5 14.375Z" stroke="#C7CFDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg v-show="!show_pass" width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.5462 18.7353C18.9855 18.4005 19.0701 17.773 18.7353 17.3338C18.4005 16.8946 17.773 16.8099 17.3338 17.1447L18.5462 18.7353ZM12 20V21C12.0054 21 12.0109 21 12.0163 20.9999L12 20ZM1 12L0.118844 11.5272C-0.0347896 11.8135 -0.0397388 12.1566 0.105573 12.4472L1 12ZM6.6669 6.8548C7.10584 6.51962 7.18996 5.89207 6.85478 5.45312C6.5196 5.01418 5.89204 4.93007 5.4531 5.26525L6.6669 6.8548ZM9.67209 3.26634C9.13434 3.39222 8.80045 3.93019 8.92632 4.46794C9.05219 5.00569 9.59016 5.33958 10.1279 5.21371L9.67209 3.26634ZM12 4.00003L11.9976 5.00003H12V4.00003ZM23 12L23.8819 12.4714C24.0348 12.1854 24.0395 11.8429 23.8944 11.5528L23 12ZM20.0748 14.5462C19.7193 14.9688 19.7736 15.5996 20.1962 15.9552C20.6187 16.3108 21.2496 16.2565 21.6052 15.8339L20.0748 14.5462ZM14.8516 14.8017C15.2281 14.3977 15.2058 13.7649 14.8017 13.3884C14.3977 13.0119 13.7649 13.0342 13.3884 13.4383L14.8516 14.8017ZM10.5617 10.6116C10.9658 10.2351 10.9881 9.60236 10.6116 9.1983C10.2351 8.79425 9.60233 8.77191 9.19828 9.14841L10.5617 10.6116ZM17.3338 17.1447C15.7941 18.3183 13.9193 18.9685 11.9837 19.0002L12.0163 20.9999C14.3789 20.9613 16.6671 20.1677 18.5462 18.7353L17.3338 17.1447ZM12 19C8.89951 19 6.39552 17.2265 4.60454 15.3161C3.71817 14.3706 3.03543 13.4213 2.57441 12.7075C2.34452 12.3515 2.1714 12.0567 2.05712 11.8535C2.00002 11.752 1.95773 11.6736 1.93051 11.6222C1.9169 11.5964 1.90707 11.5775 1.90104 11.5657C1.89803 11.5599 1.89597 11.5558 1.89486 11.5537C1.89431 11.5526 1.894 11.552 1.89392 11.5518C1.89389 11.5517 1.89391 11.5518 1.894 11.552C1.89404 11.552 1.89415 11.5522 1.89417 11.5523C1.89429 11.5525 1.89443 11.5528 1 12C0.105573 12.4472 0.105741 12.4476 0.105925 12.4479C0.106007 12.4481 0.106206 12.4485 0.10637 12.4488C0.106698 12.4495 0.107087 12.4503 0.107539 12.4512C0.108442 12.4529 0.109592 12.4552 0.11099 12.458C0.113785 12.4635 0.117569 12.4709 0.122338 12.4802C0.131875 12.4988 0.145357 12.5247 0.162753 12.5576C0.19754 12.6233 0.248023 12.7168 0.313971 12.834C0.445792 13.0684 0.63985 13.3985 0.894336 13.7926C1.40207 14.5787 2.15683 15.6294 3.14546 16.684C5.10448 18.7736 8.10049 21 12 21V19ZM1.88116 12.4729C3.05763 10.2804 4.68936 8.36487 6.6669 6.8548L5.4531 5.26525C3.24891 6.94839 1.43015 9.08345 0.118844 11.5272L1.88116 12.4729ZM10.1279 5.21371C10.7408 5.07025 11.3682 4.99854 11.9976 5.00002L12.0023 3.00003C11.2179 2.99818 10.4359 3.08756 9.67209 3.26634L10.1279 5.21371ZM12 5.00003C15.1005 5.00003 17.6045 6.77359 19.3955 8.68397C20.2818 9.62943 20.9646 10.5787 21.4256 11.2926C21.6555 11.6485 21.8286 11.9434 21.9429 12.1465C22 12.248 22.0423 12.3265 22.0695 12.3779C22.0831 12.4036 22.0929 12.4226 22.099 12.4343C22.102 12.4402 22.104 12.4442 22.1051 12.4464C22.1057 12.4475 22.106 12.4481 22.1061 12.4482C22.1061 12.4483 22.1061 12.4483 22.106 12.4481C22.106 12.448 22.1059 12.4478 22.1058 12.4478C22.1057 12.4475 22.1056 12.4472 23 12C23.8944 11.5528 23.8943 11.5525 23.8941 11.5521C23.894 11.5519 23.8938 11.5515 23.8936 11.5512C23.8933 11.5506 23.8929 11.5498 23.8925 11.5489C23.8916 11.5471 23.8904 11.5448 23.889 11.5421C23.8862 11.5366 23.8824 11.5291 23.8777 11.5198C23.8681 11.5013 23.8546 11.4753 23.8372 11.4425C23.8025 11.3767 23.752 11.2833 23.686 11.166C23.5542 10.9317 23.3601 10.6015 23.1057 10.2075C22.5979 9.42134 21.8432 8.37062 20.8545 7.31608C18.8955 5.22646 15.8995 3.00003 12 3.00003V5.00003ZM22.1181 11.5286C21.5439 12.6028 20.8591 13.6142 20.0748 14.5462L21.6052 15.8339C22.479 14.7953 23.2421 13.6684 23.8819 12.4714L22.1181 11.5286ZM13.3884 13.4383C12.8898 13.9734 12.1389 14.1936 11.4303 14.0127L10.9354 15.9505C12.3526 16.3124 13.8544 15.8719 14.8516 14.8017L13.3884 13.4383ZM11.4303 14.0127C10.7217 13.8317 10.1683 13.2784 9.98736 12.5697L8.04955 13.0646C8.41149 14.4819 9.51816 15.5885 10.9354 15.9505L11.4303 14.0127ZM9.98736 12.5697C9.80639 11.8611 10.0266 11.1102 10.5617 10.6116L9.19828 9.14841C8.12813 10.1456 7.68762 11.6474 8.04955 13.0646L9.98736 12.5697Z" fill="#C7CFDD"/>
                  <path d="M1 1L23 23" stroke="#C7CFDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <div class="form-group__error" v-if=" $v.form.password.$dirty && !$v.form.password.minLength">
              Длинна пароля менее 6 символов
            </div>
          </div>
        </div>
      </div>
      <div class="holder holder--end">
        <button class="button" type="submit" :class="{ 'preload': loading }" :disabled="$v.form.$error">
          <span>Добавить администратора</span>
          <img src="@/assets/img/preloader.svg" alt="" class="button__preloader"/>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { minLength, required } from 'vuelidate/lib/validators'
import MaskedInput from 'vue-masked-input'
import { debounce } from 'lodash'

export default {
  name: 'AdminsCreate',
  components: {
    MaskedInput
  },
  mixins: [ validationMixin ],
  validations: {
    form: {
      fio: { required },
      email: { required },
      phone_number: { required },
      username: { required },
      password: { required, minLength: minLength(6) },
    },
  },
  data() {
    return {
      form: {
        password: ''
      },
      userSearchOptions: [],
      counterparties_codes_options: [],
      loading: false,
      show_pass: true
    }
  },
  methods: {
    onUserSearch(search, loading) {
      loading(true)
      this.searchUser(loading, search, this)
    },
    searchUser: debounce((loading, search, vm) => {
      vm.$store.dispatch('clients/GET_USER', search).then(response => {
        vm.userSearchOptions = response.data.results
        loading(false)
      })
    }, 350),
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'warn',
          title: 'Внимание!',
          text: 'Проверьте правильность заполнения полей формы.'
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.loading = true
      this.$store.dispatch('usersMain/POST_ADMIN', this.form)
        .then(() => {
          this.loading = false
          this.$router.push({ name: 'users-admins' })
          this.$notify({
            type: 'success',
            title: 'Успех!',
            text: 'Администратор добавлен.'
          })
        })
        .catch(() => {
          this.loading = false
          this.$notify({
            type: 'error',
            title: 'Ошибка!',
            text: 'Ошибка добавления администратора.'
          })
        })
    },
    onPasswordGen() {
      this.form.password = ''
      const charset = 'abcdefghijklmnopqrstuvwxyz0123456789'
      for (let i = 0, n = charset.length; i < 6; i++) {
        this.form.password += charset.charAt(Math.floor(Math.random() * n))
      }
      if (!this.show_pass || !this.show_rep_pass) {
        this.show_pass = true
        this.show_rep_pass = true
      }
    },
    getLabel (option) {
      if (typeof option === 'object') {
        if (Object.prototype.hasOwnProperty.call(!option, this.label)) {
          return console.warn(
            `[vue-select warn]: Label key "option.${this.label}" does not` +
            ` exist in options object ${JSON.stringify(option)}.\n` +
            'https://vue-select.org/api/props.html#getoptionlabel'
          )
        }
        return option[this.label]
      }
      return option
    },
  }
}
</script>
